import { lazy } from "react";
//import { Outlet } from "react-router-dom";
import FrontLayout from "layout/frontLayout";

//components imports

//pages import
const Login = lazy(() => import("modules/auth/login"));
const About = lazy(() => import("pages/About"));
const Howto = lazy(() => import("pages/Howto"));
const Contact = lazy(() => import("pages/Contact"));
const Home = lazy(() => import("pages/Home"));
const Donate = lazy(() => import("pages/Donate"));
const Privacy = lazy(() => import("pages/Privacy"));
const Terms = lazy(() => import("pages/Terms"));
const FrontRoutes = {
    path: "/",
    element: <FrontLayout />,
    children: [
      { path: "", element: <Home /> },  // Set home page content here
      { path: "howto", element: <Howto /> },
      { path: "about", element: <About /> },
      { path: "contact", element: <Contact /> },
      { path: "login", element: <Login /> }, // Ensure this route exists
      { path: "donate", element: <Donate /> },
      { path: "privacy", element: <Privacy /> },
      { path: "terms-of-use", element: <Terms /> },
    ],
  };
  
  export default FrontRoutes;